module.exports = {"330281001":"梨洲街道","330281002":"凤山街道","330281003":"兰江街道","330281004":"阳明街道","330281005":"低塘街道","330281006":"朗霞街道","330281100":"临山镇","330281101":"黄家埠镇","330281102":"小曹娥镇","330281103":"泗门镇","330281106":"马渚镇","330281108":"牟山镇","330281109":"丈亭镇","330281110":"三七市镇","330281111":"河姆渡镇","330281112":"大隐镇","330281113":"陆埠镇","330281114":"梁弄镇","330281115":"大岚镇","330281116":"四明山镇","330281201":"鹿亭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330281.json
// module id = 886
// module chunks = 0